'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const fastdom=require('fastdom');
const BaseDirective=require('../../../dist-es6/client/angularCommon/baseDirective');
const Formatters=require('../../../dist-es6/client/formatters');let

RippleButtonDirective=function(_BaseDirective){_inherits(RippleButtonDirective,_BaseDirective);function RippleButtonDirective(){_classCallCheck(this,RippleButtonDirective);return _possibleConstructorReturn(this,_BaseDirective.apply(this,arguments))}RippleButtonDirective.prototype.




link=function link($scope,$element,$attrs){
const color=$attrs.pulsarRippleButton!=='pulsar-ripple-button'&&$attrs.pulsarRippleButton.length!==0?$attrs.pulsarRippleButton:null;
const _buttonElement=angular.element($element);

_buttonElement.on('click',function(event){
fastdom.measure(function(){
const{top:buttonTop,left:buttonLeft}=_buttonElement.offset();
const X=event.pageX-buttonLeft;
const Y=event.pageY-buttonTop;

let styles=`top: ${Y}px; left: ${X}px;`;
if(color){
styles+=`background-color: ${color};`;
}

fastdom.mutate(function(){
const _rippleDiv=angular.element(`<div class="ripple" style="${styles}"></div>`);
_buttonElement.append(_rippleDiv);
setTimeout(function(){
fastdom.mutate(function(){
const el=angular.element(_rippleDiv);
if(el){
el.remove();
}
});
},900);
});
});
});
};_createClass(RippleButtonDirective,[{key:'restrict',get:function(){return'A'}}]);return RippleButtonDirective}(BaseDirective);


module.exports=RippleButtonDirective;
//# sourceMappingURL=rippleButtonDirective.js.map
